import React, { Component } from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from "@material-ui/core";

import ErrorMessageDialog from "../ui/ErrorMessageDialog.js"

import DewarsList from "./DewarsScreen/DewarsList.js"

import api from "../api.js";

class SelectDewarDialog extends Component {

    constructor(props) {

        super(props)

        this.state = {
            dialog: undefined,
            selected: undefined,
            dewars: [],
        }

    }

	handle_error = (error) => {
        let message = error instanceof String ? error : error.message
		this.setState({
			dialog: <ErrorMessageDialog 
				message = {message}
				onClose = {async () => {
                    try {
                        await this.update()
                        this.setState({dialog: undefined})
                    }
                    catch(e) {
                        this.handle_error(e)
                    }
				}}
			/>
		})
	}

    update = async () => {
        let response = await api.dewars.list()
        this.setState({dewars: response.dewars})
    }

    componentDidMount = async () => {
        try {
            await this.update()
        }
        catch(e) {
            this.handle_error(e)
        }
    }

    render() {
        
        if (this.state.dialog) {
            return this.state.dialog;
        }

        return <Dialog open fullWidth = {true} >

            <DialogTitle> Выбрать сосуд Дьюара </DialogTitle>

            <DialogContent style={{display: "flex"}}>
                <DewarsList
                    dewars={this.state.dewars}
                    selected={this.state.selected}
                    onDewarClick={(dewar) => {
                        if (this.state.selected && this.state.selected.id === dewar.id) {
                            if (typeof this.props.onSelect === "function") {
                                this.props.onSelect(dewar)
                            }                            
                        } else {
                            this.setState({selected: dewar})
                        }
                    }}
                />
            </DialogContent>

            <DialogActions>

                <Button
                    disabled = {!this.state.selected}
                    onClick = {e => {
                        e.stopPropagation()
                        this.handle_onSelect(this.state.selected)
                    }}
                >
                    Выбрать
                </Button>

                <Button
                    onClick = {e => {
                        e.stopPropagation()
                        if (typeof this.props.onCancel === "function") {
                            this.props.onCancel()
                        }
                    }}
                >
                    Отмена
                </Button>

            </DialogActions>

        </Dialog>

    }

}

export default SelectDewarDialog